module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Page</span></div>\r\n<div class=\"row prop-detail\">\r\n	<div>\r\n		<div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n			<input type=\"radio\" name=\"next\" value=\"next\" class=\"form-radio-group\"/>\r\n			<label class=\"form-group-label\">Next</label>\r\n		</div>\r\n	</div>\r\n	<div>\r\n		<div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n			<input type=\"radio\" name=\"previous\" value=\"previous\" class=\"form-radio-group\"/>\r\n			<label class=\"form-group-label\">Previous</label>\r\n		</div>\r\n	</div>\r\n	<div>\r\n		<div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n			<input type=\"radio\" name=\"back\" value=\"back\" class=\"form-radio-group\" />\r\n			<label class=\"form-group-label\">Back to last shown</label>\r\n		</div>\r\n	</div>\r\n	<div>\r\n		<div class=\"col-md-12 prop-sublabel form-group-flex prop-separator-radio\">\r\n			<input type=\"radio\" name=\"specific\" value=\"specific\" class=\"form-radio-group\"/>\r\n			<label class=\"form-group-label\">Specific</label>\r\n		</div>\r\n		<div class=\"col-md-12 nopadding-r\" style=\"padding-left:30px;padding-top:5px;\">\r\n			<select name=\"selectSpecificPage\" id=\"selectSpecificPage\" disabled=\"disabled\" >\r\n			</select>\r\n		</div>\r\n	</div>\r\n</div>")
  }
  return __output;

}